<template>
  <span>{{ name }}</span>
</template>

<script>

export default {
  name: 'CatalogName',
  props: {
    id: { type: String, default: '' },
  },
  data() {
    return {
      name: '',
    };
  },
  watch: {
    id: {
      immediate: true,
      async handler(val) {
        if (!val) {
          this.name = '';
        } else {
          this.name = '...';
        }

        this.$nextTick(async () => {
          const response = await this.$services.catalogsrest.readOne(val);
          if (response.data) {
            this.name = response.data.name;
          } else {
            this.name = val;
          }
        });
      },
    },
  },
};
</script>
